import type { ReactNode } from 'react';
import type { VideoPreparationGuideDefinition } from '@ngsos/portal-core/video';

import { getVideoGuidanceImage } from '../assets/getVideoGuidanceImage';
import { Text } from '../primitives/Text';
import { useTheme } from '../theme/ThemeProvider';
import { VideoPreparation } from './VideoPreparation';

export type VideoPreparationGuideProps = {
  guide: VideoPreparationGuideDefinition;
  title: string;
  actionLabel: string;
  language?: string;
  footerLabel?: string;
  footer?: ReactNode;
  inverse?: boolean;
};

export function VideoPreparationGuide({
  guide,
  title,
  actionLabel,
  language = 'en',
  footerLabel,
  footer,
  inverse = false,
}: VideoPreparationGuideProps) {
  const theme = useTheme();
  const image = getVideoGuidanceImage(guide.image, language);
  return (
    <VideoPreparation
      title={title}
      actionLabel={actionLabel}
      image={image.source}
      aspectRatio={image.width / image.height}
      testID={guide.testID}
      inverse={inverse}
      footer={
        footer ??
        (footerLabel === undefined ? undefined : (
          <Text
            color={inverse ? theme.colors.textInverse : theme.colors.text}
            style={{ textAlign: 'center' }}
          >
            {footerLabel}
          </Text>
        ))
      }
    />
  );
}
